import { all, takeEvery, put, call, fork } from "redux-saga/effects";
import GrpSwitchHelper from "@iso/lib/api/grpSwitchHelper";
import actions from "./actions";
import {redirectPage} from '@iso/lib/helpers/utility';
//import JwtAuthentication from '../../helpers/jwtAuthentication';

/**** list of user record *******/
export function* GrpSwitchFindByIdRequest() {
  console.log("search request");
  yield takeEvery(actions.GRP_SWITCH_FETCH_ID, function* ({ payload }) {
    try {
      console.log("check");
      const searchResult = yield call(GrpSwitchHelper.findById, payload.listid);
      if (searchResult.status) {
        yield put(actions.grpSwitchListById(searchResult.result, searchResult.message));
      } else if (searchResult.status == 0) {
        redirectPage("/404");
      }
    } catch (error) {}
  });
}
/*****end*************/

/************************************** End UPDATE User  Function ***************************************/

export default function* rootSaga() {
  yield all([fork(GrpSwitchFindByIdRequest)]);
}
